import { render, staticRenderFns } from "./CoachManage.vue?vue&type=template&id=8af2d4ce&scoped=true"
import script from "./CoachManage.vue?vue&type=script&lang=js"
export * from "./CoachManage.vue?vue&type=script&lang=js"
import style0 from "./CoachManage.vue?vue&type=style&index=0&id=8af2d4ce&prod&lang=scss&scoped=true"
import style1 from "./CoachManage.vue?vue&type=style&index=1&id=8af2d4ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af2d4ce",
  null
  
)

export default component.exports